import ApplicationController from '../application_controller';

export default class extends ApplicationController {
  connect() {
    const radiosConHermanos = document.querySelectorAll('input[type="radio"][name="listados_filters[con_hermanos]"]')
    radiosConHermanos.forEach((radio) => {
      radio.addEventListener('change', (e) => {
        this.#cambiarEstado(e.target.value === 'true' && e.target.checked);
      });
    });
    const radioTrue = Array.from(radiosConHermanos).find((radio) => radio.value === 'true' && radio.checked);
    this.#cambiarEstado(radioTrue);
  }

  #cambiarEstado(habilitar) {
    this.element.querySelectorAll('input').forEach((input) => {
      input.checked = habilitar && input.value === 'true';
      input.disabled = !habilitar;
    });
  }
}
